import getDifference from 'date-fns/difference_in_milliseconds'

const isStale = (
  lastUpdated: Date | string | null,
  maxAge: number
): boolean => {
  if (!lastUpdated) return true

  try {
    const diffrence = getDifference(Date.now(), new Date(lastUpdated))

    return diffrence > maxAge
  } catch (err) {
    return true
  }
}

export { isStale }
